import DashboardIcon from "@mui/icons-material/Dashboard";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import WarningIcon from "@mui/icons-material/Warning";
import DeleteIcon from "@mui/icons-material/Delete";
import PersonIcon from "@mui/icons-material/Person";
import HelpIcon from "@mui/icons-material/Help";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import type { SvgIconComponent } from "@mui/icons-material";
import { routes } from "@/constants/routes";

export const DRAWER_WIDTH = 256;

/** Viewport breakpoint: persistent sidebar from `md` up; below, drawer + app bar. */
export const NAV_DESKTOP_UP = "md" as const;

export interface NavItem {
  label: string;
  i18nKey: string;
  path: string;
  icon: SvgIconComponent;
  requiresAuth: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  {
    label: "Import keys",
    i18nKey: "nav.importKeys",
    path: routes.importKeys,
    icon: FileUploadIcon,
    requiresAuth: false,
  },
  {
    label: "Dashboard",
    i18nKey: "nav.dashboard",
    path: routes.dashboard,
    icon: DashboardIcon,
    requiresAuth: true,
  },
  {
    label: "Upload",
    i18nKey: "nav.upload",
    path: routes.upload,
    icon: CloudUploadIcon,
    requiresAuth: true,
  },
  {
    label: "Key Vault",
    i18nKey: "nav.keyVault",
    path: routes.keys,
    icon: VpnKeyIcon,
    requiresAuth: true,
  },
  {
    label: "Quarantine",
    i18nKey: "nav.quarantine",
    path: routes.quarantine,
    icon: WarningIcon,
    requiresAuth: true,
  },
  {
    label: "Trash",
    i18nKey: "nav.trash",
    path: routes.trash,
    icon: DeleteIcon,
    requiresAuth: true,
  },
  {
    label: "Account",
    i18nKey: "nav.account",
    path: routes.account,
    icon: PersonIcon,
    requiresAuth: true,
  },
  {
    label: "Help",
    i18nKey: "nav.help",
    path: routes.help,
    icon: HelpIcon,
    requiresAuth: true,
  },
];
